import { Box, Stack, Typography } from '@mui/material'
import { alpha, useTheme } from '@mui/material/styles'
import type { ReactNode } from 'react'

type PlansNoticeProps = {
  icon: ReactNode
  title?: string
  body: string
  /** `accent` for something that changed; `quiet` for something to know. */
  tone?: 'quiet' | 'accent'
}

/**
 * A plain sentence on the page, said once and before it matters — that online
 * payment is not switched on, or what came back from a payment that was
 * started. Never a dialog: none of these need dismissing to be understood.
 */
export default function PlansNotice({ icon, title, body, tone = 'quiet' }: PlansNoticeProps) {
  const theme = useTheme()
  const c = theme.affexy.colors
  const accent = tone === 'accent'

  return (
    <Box
      sx={{
        display: 'flex',
        gap: 1.5,
        alignItems: 'flex-start',
        p: 1.75,
        borderRadius: '14px',
        bgcolor: accent ? alpha(c.coral, 0.05) : c.gray50,
        border: `1px solid ${accent ? alpha(c.coral, 0.25) : c.ink08}`,
      }}
    >
      <Box sx={{ color: accent ? c.coral : c.ink48, display: 'flex', mt: '1px' }}>{icon}</Box>
      <Stack spacing={0.25} sx={{ minWidth: 0 }}>
        {title && <Typography sx={{ fontSize: 14, fontWeight: 700 }}>{title}</Typography>}
        <Typography sx={{ fontSize: 13.5, color: c.ink72, lineHeight: 1.5 }}>{body}</Typography>
      </Stack>
    </Box>
  )
}
